import type { CollectionListItemFragment } from '#graphql-operations'
import { ROOT_COLLECTION } from '~/constants'

export type CollectionListItemFragmentWithChildren = CollectionListItemFragment & { children: { [id: string]: CollectionListItemFragmentWithChildren } }

export function buildTree(collections?: CollectionListItemFragment[] | null) {
  if (collections == null)
    return {}

  const lookup: { [key: string]: CollectionListItemFragmentWithChildren } = {}
  const rootNodes: { [slug: string]: CollectionListItemFragmentWithChildren } = {}

  for (const collection of collections)
    lookup[collection.slug] = { ...collection, children: {} }

  for (const collection of collections) {
    if (collection.parent && collection.parent.name === ROOT_COLLECTION) {
      rootNodes[collection.slug] = lookup[collection.slug]
    }
    else if (collection.parent && collection.parent.slug in lookup) {
      if (collection.slug !== collection.parent.slug)
        lookup[collection.parent.slug].children[collection.slug] = lookup[collection.slug]
      else
        console.error(`Circular reference detected in collection with slug ${collection.slug}`)
    }
  }

  return rootNodes
}
